import { render, staticRenderFns } from "./PDisplayCounterpart.vue?vue&type=template&id=d05b072a"
import script from "./PDisplayCounterpart.vue?vue&type=script&lang=js"
export * from "./PDisplayCounterpart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports